import { useMiningDataManager } from '../../hooks/useMiningDataManager';
import { calculateAVGDifficulty } from "../../utils/calculate"



export default function Average_D (){
    const miningData = useMiningDataManager();
    const miners = miningData.miners;
    const AVG_Difficulty = calculateAVGDifficulty(miners)

    return(
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 short:gap-2">
        <div className="card p-4 short:p-3">
          <div className="flex items-center space-x-3">
            <div className="w-9 h-9 bg-orange-100 dark:bg-orange-500/15 rounded-lg flex items-center justify-center flex-shrink-0">
              <svg className="w-4 h-4 text-orange-700 dark:text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
              </svg>
            </div>
            <div className="min-w-0">
              <p className="stat-label">Avg Difficulty SHA256</p>
              <p className="text-xl tall:text-2xl short:text-base font-bold tabular-nums text-gray-900 dark:text-white leading-tight truncate">
                {AVG_Difficulty.sha256D_AVG}
              </p>
            </div>
          </div>
        </div>

        <div className="card p-4 short:p-3">
          <div className="flex items-center space-x-3">
            <div className="w-9 h-9 bg-sky-100 dark:bg-sky-500/15 rounded-lg flex items-center justify-center flex-shrink-0">
              <svg className="w-4 h-4 text-sky-700 dark:text-sky-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
              </svg>
            </div>
            <div className="min-w-0">
              <p className="stat-label">Avg Difficulty Scrypt</p>
              <p className="text-xl tall:text-2xl short:text-base font-bold tabular-nums text-gray-900 dark:text-white leading-tight truncate">
                {AVG_Difficulty.scryptD_AVG.toFixed(2)}
              </p>
            </div>
          </div>
        </div>
      </div>
    )
}
